import React, { Component } from 'react'
import smoothscroll from 'smoothscroll-polyfill';
import { connect } from 'react-redux';
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import Menu from './menu';
import shareImage from '../images/share.png';

import './reset.css';

class Layout extends Component {
  componentDidMount() {
    smoothscroll.polyfill();
  }

  render() {
    const { children, page, config } = this.props;

    return (
      <StaticQuery
        query={graphql`
          query TitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'viewport', content: 'width=device-width, initial-scale=1' },
                { name: 'description', content: 'Take this quiz to find the rare diamond jewelry that perfectly matches the unique qualities of the woman you love.' },
                { name: 'keywords', content: 'forevermark' },
                { name: 'og:url', content: config.siteUrl },
                { name: 'og:type', content: 'website' },
                { name: 'og:title', content: data.site.siteMetadata.title },
                { name: 'og:description', content: 'Take this quiz to find the rare diamond jewelry that perfectly matches the unique qualities of the woman you love.' },
                { name: 'og:image', content: shareImage }
              ]}
            >
              <html lang="en" />
              <link rel="stylesheet" href="https://use.typekit.net/lhd5awx.css" />
              <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.css" />
              <script>
                window.scroll(0,0);
              </script>
              <body className={page} />
            </Helmet>
            {/* <Menu /> */}
            {children}
          </>
        )}
      />
    )
  }
}

const mapStateToProps = ({ page, config }) => {
  return { page, config };
}

export default connect(mapStateToProps)(Layout)
